import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import AnimatedPage from "../../components/AnimatedPage";
import { COMPANY } from "../../constants/routes";
import PricingColumn from "../../components/PricingColumn";
import { toggleModal } from "../../reducers/modalReducer";
import { getRequest, showMessage } from "../../config";
import SubscriptionPaymentConfirm from "../../components/modals/SubscriptionPaymentConfirm/SubscriptionPaymentConfirm";
import { useParams, useSearchParams } from 'react-router-dom';

const BillingDetail = () => {

    const dispatch = useDispatch();
    const user = useSelector(state => state.user);
    let [plan, setPlan] = useState();
    let [stripeHistory, setStripeHistory] = useState();
    let [upcomingInvoice, setUpcomingInvoice] = useState();
    let [company, setCompany] = useState(null);
    const { id: companyId } = useParams();
    const [searchParams] = useSearchParams();
    const selectedPlan = searchParams.get('plan') || 'Free';

    useEffect(() => {
        if (!company) getCompany();
    }, [])


    const getCompany = async () => {
        let res = await getRequest(`/company/get/${companyId}`);
        if (res?.['code'] == 200) setCompany(res?.['body']);
    };

    useEffect(() => {
        (async () => {
            if (companyId !== "all") {
                res = await getRequest(`/payment/stripeHistory/${companyId}`, 'not-showMessage');
                if (res && res.code == 200 && res.body) setStripeHistory(res.body);

                res = await getRequest(`/payment/upcomingInvoice/${companyId}`, 'not-showMessage');
                if (res && res.code == 200 && res.body) setUpcomingInvoice(res.body);
            }
        })();
    }, [companyId]);


    const handlePaymentPopup = (paymentPlan) => {
        if (paymentPlan == 'Portfolio Pro') paymentPlan = "Pro";
        let activePlans = ['Free', 'Lite', 'Pro'];
        if (activePlans.includes(paymentPlan)) {
            setPlan(paymentPlan);
            // dispatch(toggleModal({ open: 'subscriptionPayment' }));
            dispatch(toggleModal({ open: 'subscriptionPaymentConfirm' }));
        }
    };

    return (
        <AnimatedPage>
            <div className="py3rem bg38 df aic fdc mih100vh">
                <div className="df fdc aic jcc w100 mb2rem">
                    <h1 className="w100 c15 fs2rem lh2 fw500 tac">Subscription & <span className="c4">Upgrade</span> Plans</h1>
                    <p className="w100 fs1rem mt0-5rem lh2 c2 fw400 tac">Choose the right Diligentsia Plan for you</p>
                </div>
                <div className='df fdc ais w90'>
                    <div className="bg1" style={{ minHeight: "70vh" }}>

                        {company && Object.keys(company).length > 0 && <>
                            {(company?.['advisors']?.[user['_id']] || company?.['investors']?.[user['_id']])
                                ? <div className="df jcc fdc aic py3rem c1">
                                    <div className={`pt10rem pb1-5rem c1 px8rem sm-px1rem pricing-table-saf pricing-advisor-table dg gtcr3-xl  gtcr2-md rg5rem cg2rem gg4rem-xl`}>
                                        {
                                            selectedPlan.toLowerCase() === "pro" ? <>
                                                <div></div>
                                                <PricingColumn company={company} plan="Pro" component="Billing" handlePaymentPopup={handlePaymentPopup}>
                                                    <label for="proOption" className="df w100 jcc mt1rem">
                                                        <input onClick={() => dispatch(toggleModal({ open: 'payment' }))} onChange={() => setPlan("Pro")} name="pricingPlan" id="proOption" className="op0 pen" type="radio" />
                                                        <span data-testid="purchasePro" className="fs1rem br5px shadow cp c1 py0-5rem px1rem fw550 bg4 bg3-hover td250">
                                                            Purchase Now
                                                        </span>
                                                    </label>
                                                </PricingColumn>
                                            </> : <>
                                                <PricingColumn company={company} plan="Portfolio Pro" isAdvisor={true} isInvestor={true} component="Billing" handlePaymentPopup={handlePaymentPopup} />
                                                <PricingColumn company={company} plan="Pro" component="Billing" handlePaymentPopup={handlePaymentPopup}>
                                                    <label for="proOption" className="df w100 jcc mt1rem">
                                                        <input onClick={() => dispatch(toggleModal({ open: 'payment' }))} onChange={() => setPlan("Pro")} name="pricingPlan" id="proOption" className="op0 pen" type="radio" />
                                                        <span data-testid="purchasePro" className="fs1rem br5px shadow cp c1 py0-5rem px1rem fw550 bg4 bg3-hover td250">
                                                            Purchase Now
                                                        </span>
                                                    </label>
                                                </PricingColumn>
                                                <PricingColumn company={company} plan="Pro PLUS" component="Billing" handlePaymentPopup={handlePaymentPopup} />
                                            </>
                                        }

                                    </div>
                                </div>
                                : <div className={`gtcr4-xl mt5rem py5rem px2rem br8px c1 dg gtcr2-md rg5rem cg2rem gg1rem-xl pricing-table-saf`}>

                                    <PricingColumn company={company} plan="Free" component="Billing" handlePaymentPopup={handlePaymentPopup}>
                                        {(user['role'] !== 'Advisor' && user['role'] !== 'Investor') &&
                                            <label for="partnerOption" className="df w100 jcc mt1rem">
                                                <input onClick={handlePaymentPopup} onChange={() => setPlan("Free")} name="pricingPlan" id="partnerOption" className="op0 pen" type="radio" />
                                                <span data-testid="purchaseFree" className="fs1rem br5px shadow cp c1 py0-5rem px1rem fw550 bg4 bg3-hover td250">Purchase Now</span>
                                            </label>
                                        }
                                    </PricingColumn>
                                    <PricingColumn company={company} plan="Lite" component="Billing" handlePaymentPopup={handlePaymentPopup}>
                                        {(user['role'] !== 'Advisor' && user['role'] !== 'Investor') &&
                                            <label for="liteOption" className="df w100 jcc mt1rem">
                                                <input onClick={() => dispatch(toggleModal({ open: 'payment' }))} onChange={() => setPlan("Lite")} name="pricingPlan" id="liteOption" className="op0 pen" type="radio" />
                                                <span data-testid="purchaseLite" className="fs1rem br5px shadow cp c1 py0-5rem px1rem fw550 bg4 bg3-hover td250">Purchase Now</span>
                                            </label>
                                        }
                                    </PricingColumn>
                                    <PricingColumn company={company} plan="Pro" component="Billing" handlePaymentPopup={handlePaymentPopup}>
                                        <label for="proOption" className="df w100 jcc mt1rem">
                                            <input onClick={() => dispatch(toggleModal({ open: 'payment' }))} onChange={() => setPlan("Pro")} name="pricingPlan" id="proOption" className="op0 pen" type="radio" />
                                            <span data-testid="purchasePro" className="fs1rem br5px shadow cp c1 py0-5rem px1rem fw550 bg4 bg3-hover td250">Purchase Now</span>
                                        </label>
                                    </PricingColumn>
                                    <PricingColumn company={company} plan="Pro PLUS" component="Billing" handlePaymentPopup={handlePaymentPopup} />
                                </div>
                            }
                        </>
                        }
                        <SubscriptionPaymentConfirm plan={plan} defaultStep={plan === "Free" ? "freeMembership" : "subscriptionUpgrade"} company={company} companyId={companyId} />

                    </div>
                    <div className="w100 df jcc aic">
                        <p className="c15 fs14px mt0-5rem op60" style={{ letterSpacing: '1px' }}>
                            If you wish to cancel or downgrade your subscription, please contact support
                        </p>
                    </div>
                </div>
            </div>
        </AnimatedPage>
    )
}

export default BillingDetail